import api from "@/config/axiosConfig";
import { AxiosResponse } from "axios";
import { TripLodging } from "@/types/accommodation";

interface UploadImagesResponse {
  data: {
    urls: string[];
  };
  message: string;
}

class AccommodationService {
  async uploadCustomAccommodationImages(
    images: File[]
  ): Promise<UploadImagesResponse> {
    const formData = new FormData();
    images.forEach((file, index) => {
      formData.append(`images[${index}]`, file);
    });

    const response = await api.lodgings.post("/custom/images", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      data: {
        urls: response.data.data.urls,
      },
      message: "Images uploaded successfully",
    };
  }

  // async createCustomLodging(lodging: TripLodging): Promise<AxiosResponse> {
  //   return await api.lodgings.post("/custom", lodging);
  // }
}

export const accommodationService = new AccommodationService();
export default accommodationService;
